<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    window.app = this
    let theme = localStorage.getItem('theme') || 'green'
    import(`@/assets/element_themes/${theme}-element-variables.scss`)
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  min-width: 100%;
  min-height: 100%;
  /*overflow-y: auto;*/
  font-family: PingFangSC, 'helvetica neue', 'hiragino sans gb', tahoma, 'microsoft yahei ui', 'microsoft yahei', simsun, sans-serif;
  font-weight: normal;
  font-size: 13px;
}

#app {
  height: 100%;
}
</style>
